import { VpButton } from '@vtmn-play/react';
import { VtmnTooltip } from '@vtmn/react';
import { useTranslation } from 'react-i18next';
import './footer.scss';

export interface FooterProps {
  ctaLabel: string;
  validateAction: () => void;
  cancelAction: () => void;
  isValidateActionDisabled?: boolean;
  comment?: string;
  isLoading?: boolean;
  tooltipComment?: string;
}

export const Footer = ({
  ctaLabel,
  validateAction,
  cancelAction,
  isValidateActionDisabled = false,
  comment,
  isLoading = false,
  tooltipComment = '',
}: FooterProps) => {
  const { t } = useTranslation();

  return (
    <footer className="footer" data-testid="footer">
      <div data-testid="footer-comment">{comment ?? ''}</div>
      <div className="footer-buttons">
        <VpButton
          variant="secondary"
          shape="squared"
          onClick={cancelAction}
          data-testid="footer_button_cancel"
        >
          {t('footer.cancel-button')}
        </VpButton>
        <VtmnTooltip position="left" tooltip={tooltipComment}>
          <VpButton
            shape="squared"
            onClick={validateAction}
            data-testid="footer_button_validate"
            disabled={isValidateActionDisabled}
            loading={isLoading}
          >
            {ctaLabel}
          </VpButton>
        </VtmnTooltip>
      </div>
    </footer>
  );
};
